import React from 'react';

const Backward = () => {
  return (
    <svg
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 9C0 9.3428 0.127326 9.63663 0.401567 9.89128L8.02155 17.3546C8.23702 17.57 8.51126 17.6876 8.83448 17.6876C9.4809 17.6876 10 17.1783 10 16.522C10 16.1988 9.86288 15.9148 9.6474 15.6895L2.78159 9L9.6474 2.31048C9.86288 2.08521 10 1.79138 10 1.47796C10 0.821743 9.4809 0.312439 8.83448 0.312439C8.51126 0.312439 8.23702 0.429971 8.02155 0.645446L0.401567 8.09892C0.127326 8.36337 0 8.6572 0 9Z"
        fill="#1F1E23"
      />
    </svg>
  );
};

export default Backward;
